import en from './incentiveStrings.en';

export default {
  en,
};
